import { FC, useEffect, useState } from "react";
import { useRouter } from "next/router";
import cn from "classnames";
import Image from "next/image";
import LaptopIcon from "@svg/laptop";
import AngleLeftIcon from "@svg/angle-left";
import MegaMenuChild from "./megamenu-sidebar/child-recursive";
import classNames from "classnames";
import { IMegamenuInput, ImegaMenuMainItem } from "features/home/helpers/types";

const debounce = (func: Function, wait: number) => {
  let timeout: NodeJS.Timeout;
  const debouncedFunction = function executedFunction(...args: any[]) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };

  debouncedFunction.cancel = () => {
    clearTimeout(timeout);
  };

  return debouncedFunction;
};

interface IProps {
  megamenu?: IMegamenuInput;
}
const MegaMenu: FC<IProps> = ({ megamenu }) => {
  const [megamenuItems, setmegamenuItems] = useState<ImegaMenuMainItem[]>([]);
  const [levelActivated, setLevelActivated] = useState<ImegaMenuMainItem>();

  useEffect(() => {
    if (!megamenu) return;

    const items = megamenu.data.filter((item) => item.children);
    setmegamenuItems(items);
    setLevelActivated(items[0]);
  }, [megamenu]);

  useEffect(() => {
    const target = document.getElementById("goftino_w");
    if (!target) return;

    target.classList.add("hidden");
    return () => {
      target.classList.remove("hidden");
    };
  }, []);

  const router = useRouter();
  const onClickHandler = (url: string) => {
    router.push(url);
  };

  const debouncedHandleMouseEnter = debounce(
    (item: ImegaMenuMainItem) => setLevelActivated(item),
    200
  );

  const handleMouseLeave = () => {
    debouncedHandleMouseEnter.cancel();
  };
  const browserHeight = typeof window !== "undefined" ? window.innerHeight : 0;

  return megamenu ? (
    <div
      className={classNames(
        "z-[100] mx-auto hidden  max-h-[70vh] h-[484px] flex-row md:flex w-[544px] bg-zinc-50 overflow-hidden [@media(min-width:1232px)]:rounded-b-lg",
        { "max-h-[60vh]": browserHeight <= 500 }
      )}
    >
      <div
        className={classNames(
          "relative h-[484px] w-[264px]  bg-white  ltr-number max-h-[70vh] overflow-x-hidden overflow-y-auto scrollMenu ",
          { "max-h-[60vh]": browserHeight <= 500 }
        )}
      >
        {megamenuItems.map((item) => {
          return (
            <div
              dir="rtl"
              key={item.id}
              className={cn(
                "flex relative cursor-pointer items-center group  headline-xxsm  text-fds-primary   focus:bg-fds-brand-light min-h-11  h-11  px-2  border-l-2 border-l-transparent  box-content",
                {
                  "bg-fds-brand-light border-l-2 !border-l-fds-brand":
                    levelActivated?.id === item.id,
                }
              )}
              onMouseEnter={() => debouncedHandleMouseEnter(item)}
              onClick={() => onClickHandler(item.mainurl || item.url)}
            >
              {item.icon ? (
                <Image
                  className={cn({
                    megaMenuImage: levelActivated?.id === item.id,
                  })}
                  src={item.icon}
                  width={20}
                  height={20}
                  alt={item.name}
                />
              ) : (
                <LaptopIcon
                  className="h-5 w-5"
                  fill={levelActivated?.id === item.id ? "#3064C0" : undefined}
                />
              )}

              <span
                className={cn("text-fds-primary headline-xxsm mr-2", {
                  "!text-fds-brand": levelActivated?.id === item.id,
                })}
              >
                {item.name}
              </span>
              <AngleLeftIcon
                className="absolute left-2 h-4     w-4     text-fds-icon-tertiary "
                fill={levelActivated?.id === item.id ? "#3064C0" : undefined}
              />
            </div>
          );
        })}
      </div>
      <>
        {levelActivated?.children && (
          <MegaMenuChild
            megaMenuItem={levelActivated}
            activeLevel={levelActivated}
            onMouseOver={handleMouseLeave}
          />
        )}
      </>
    </div>
  ) : null;
};

export default MegaMenu;
